// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1tJHS","col":"styles_col__1OBbs","fulfillmentStatus":"styles_fulfillmentStatus__19Lp1","emailCol":"styles_emailCol__3Qf7x"};